class StationContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.reasonSelect = this.form.querySelector('[name="contact_reason"]');
    this.orderField = this.form.querySelector('.station-contact__order-field');

    this.setupConditionalFields();
    this.applyPrefillFromQuery();
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  setupConditionalFields() {
    if (!this.reasonSelect || !this.orderField) return;

    const orderReasons = ['order_status', 'return_exchange', 'shipping_issue'];
    const input = this.orderField.querySelector('input');

    const sync = () => {
      const visible = orderReasons.includes(this.reasonSelect.value);
      this.orderField.hidden = !visible;
      if (input) input.required = visible;
    };

    this.reasonSelect.addEventListener('change', sync);
    sync();
  }

  applyPrefillFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const reason = params.get('reason');
    const orderNumber = params.get('order');
    const email = params.get('email');

    if (email) {
      const emailInput = this.form.querySelector('[name="email"]');
      if (emailInput) emailInput.value = email;
    }

    if (reason && this.reasonSelect) {
      this.reasonSelect.value = reason;
      this.reasonSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (orderNumber) {
      const orderInput = this.form.querySelector('[name="order_number"]');
      if (orderInput) orderInput.value = orderNumber;
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    const workerUrl = this.dataset.workerUrl || '';
    const brand = this.dataset.brand || '';
    const brandId = this.dataset.brandId || '';
    const fallbackEmail = this.dataset.fallbackEmail || '';

    if (!workerUrl) {
      this.setState('error', fallbackEmail);
      return;
    }

    this.setState('submitting');

    const formData = new FormData(this.form);
    const payload = {
      name: String(formData.get('name') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      contact_reason: String(formData.get('contact_reason') || '').trim(),
      order_number: String(formData.get('order_number') || '').trim(),
      message: String(formData.get('message') || '').trim(),
      brand,
      brand_id: brandId,
      source_url: window.location.href
    };

    const reasonLabel = this.form.querySelector('[name="contact_reason"] option:checked')?.textContent || 'Contact';
    payload.subject = payload.order_number ? `${reasonLabel} - #${payload.order_number}` : reasonLabel;

    try {
      const endpoint = `${workerUrl.replace(/\/$/, '')}/api/zendesk/ticket`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Unknown error');
      }

      this.setState('success', data.ticket_id);
    } catch (error) {
      console.error('Station contact form submission failed:', error);
      this.setState('error', fallbackEmail);
    }
  }

  setState(state, detail) {
    this.querySelectorAll('[data-state]').forEach((el) => {
      el.hidden = el.dataset.state !== state;
    });

    if (state === 'success' && detail) {
      const ticketEl = this.querySelector('[data-ticket-id]');
      if (ticketEl) ticketEl.textContent = `#${detail}`;
    }

    if (state === 'error' && detail) {
      const emailEl = this.querySelector('[data-fallback-email]');
      if (emailEl) {
        emailEl.href = `mailto:${detail}`;
        emailEl.textContent = detail;
      }
    }
  }
}

if (!customElements.get('station-contact-form')) {
  customElements.define('station-contact-form', StationContactForm);
}
